"use client";

import React from "react";
import { BlurFade } from "@/components/ui/blur-fade";

interface Stat {
  value: string;
  label: string;
}

interface StatsInlineProps {
  stats: Stat[];
}

const StatsInline = ({ stats }: StatsInlineProps) => {
  if (!stats || stats.length === 0) return null;

  return (
    <section className="py-12 px-6 bg-white">
      <div className="container max-w-5xl mx-auto">
        <BlurFade delay={0.1}>
          <div className="grid grid-cols-2 md:flex md:flex-wrap items-center justify-center md:divide-x md:divide-foreground/10 gap-y-6 md:gap-y-0">
            {stats.map((stat, i) => (
              <div
                key={i}
                className="flex flex-col items-center text-center px-4 md:px-12 py-2"
              >
                <span className="text-3xl md:text-4xl font-bold tracking-tight text-foreground">
                  {stat.value}
                </span>
                <span className="text-xs md:text-sm font-medium text-foreground/50 uppercase tracking-wider mt-1">
                  {stat.label}
                </span>
              </div>
            ))}
          </div>
        </BlurFade>
      </div>
    </section>
  );
};

export default StatsInline;
